import { CustomQuotationTypeEnum } from "@/constants/enums/customQuotationType.enum";
import { Badge } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCustomQuotationTypeLabels } from "@/hooks/useEnumLabels";

export const CustomQuotationTypeBadge = ({
  type,
}: {
  type: CustomQuotationTypeEnum | undefined;
}) => {
  const customQuotationTypeLabels = useCustomQuotationTypeLabels();
  const { t } = useTranslation("shared");
  switch (type) {
    case CustomQuotationTypeEnum.PALETTE:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-purple-200 bg-purple-50 px-2 py-0.5 text-sm font-medium text-purple-700"
        >
          {customQuotationTypeLabels.PALETTE}
        </Badge>
      );
    case CustomQuotationTypeEnum.PARCEL:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-indigo-200 bg-indigo-50 px-2 py-0.5 text-sm font-medium text-indigo-700"
        >
          {customQuotationTypeLabels.PARCEL}
        </Badge>
      );
    case CustomQuotationTypeEnum.OTHER:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-sm font-medium text-gray-700"
        >
          {customQuotationTypeLabels.OTHER}
        </Badge>
      );
    default:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-sm font-medium text-gray-700"
        >
          {t("badges.unknownValue")}
        </Badge>
      );
  }
};
